import React from 'react';

import { ChevronDownIcon } from 'lucide-react';
import moment from 'moment';
import { FormSectionCollapsible, DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, Row, Col, Badge } from 'twyne-new.ui';

import Funnel from './Funnel';
import Table from './Table';
import { numberFormat, getUniqueImpressionsCount, formatPath } from './formatters';

class ProgressionBody extends React.Component {
  state = {
    progressionType: 'Completed',
  }

  get unique() {
    return getUniqueImpressionsCount(this.props.item)
  }

  CardTitle = () => {
    const avg = this.avgCompletionTime()
    return <div className='flex items-center justify-between gap-3 flex-1 min-w-0 max-md:flex-col max-md:gap-1 max-md:w-full max-md:text-center'>
      <span className='text-md truncate max-md:w-full'>{formatPath(this.props.item)}</span>
      <div className='flex flex-col items-end gap-1 shrink-0 max-md:items-center'>
        <Badge variant='outline' color='neutral' size='sm'>total impressions: {numberFormat(this.props.item.total)}</Badge>
        {avg && <Badge variant='outline' color='neutral' size='sm'>total average completion time: {avg}</Badge>}
      </div>
    </div>
  }

  avgCompletionTime() {
    if (this.props.item.timeAvg > 0) {
      return this.formatMs(this.props.item.timeAvg)
    }
    return null
  }

  formatMs(ms) {
    const duration = moment.duration(ms)
    const avgFormated = moment.utc(duration.as('milliseconds')).format('HH:mm:ss')
    return avgFormated
  }

  ProgressionType = () => <>
    <DropdownMenu>
      <DropdownMenuTrigger>
        <Badge color='accent' size='lg' variant='light'>
          {this.state.progressionType}
          <ChevronDownIcon size={12} />
        </Badge>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        {['Impressions', 'Completed'].map((option, index) => <>
          <DropdownMenuItem
            onClick={() => this.setState({ progressionType: option })}
            key={index}
          >
            {option}
          </DropdownMenuItem>
        </>)}
      </DropdownMenuContent>
    </DropdownMenu>
  </>

  Header = () => <div className='w-full flex justify-between items-center min-w-0 max-md:flex-col max-md:gap-2'>
    <this.CardTitle />
    <this.ProgressionType />
  </div>

  render() {
    return <>
      <FormSectionCollapsible
        defaultOpen
        border
        triggerClass='py-2 px-4 twy-subtle-neutral'
        contentClass='p-4 overflow-visible'
        titleClass='text-base pr-2'
        sectionClass='w-full overflow-visible min-w-0'
        title={<this.Header />}
      >
        <Row>
          <Col size="9">
            <Table
              slots={this.props.item.children}
              id={this.props.item.id}
            />
          </Col>
          <Col size="3" className='pt-[41px]'>
            <Funnel
              item={this.props.item}
              progressionType={this.state.progressionType}
            />
          </Col>
        </Row>
      </FormSectionCollapsible>
    </>
  }
}

export default ProgressionBody;
